import { render, staticRenderFns } from "./TenantDescription.vue?vue&type=template&id=ddd00cee"
import script from "./TenantDescription.vue?vue&type=script&lang=js"
export * from "./TenantDescription.vue?vue&type=script&lang=js"
import style0 from "./TenantDescription.vue?vue&type=style&index=0&id=ddd00cee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports